var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _path11, _path12, _ellipse2, _path13, _path14, _path15, _path16, _circle, _circle2, _path17, _circle3, _circle4, _path18, _circle5, _circle6, _path19, _circle7, _circle8, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle9, _path31, _circle10, _path32, _circle11, _path33, _circle12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 476.72,
    x2: 479.556,
    xlinkHref: "#lg1",
    y1: 207.694,
    y2: 239.179
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.805,
    x2: 211.827,
    xlinkHref: "#lg2",
    y1: 136.697,
    y2: 154.298
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.932,
    x2: 211.932,
    xlinkHref: "#lg2",
    y1: 154.928,
    y2: 165.302
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.913,
    x2: 165.316,
    xlinkHref: "#lg2",
    y1: 140.658,
    y2: 140.658
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.99,
    x2: 119.747,
    xlinkHref: "#lg3",
    y1: 142.857,
    y2: 82.614
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.699,
    x2: 143.483,
    xlinkHref: "#lg1",
    y1: 91.913,
    y2: 113.804
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1551,
    stopColor: "#9b489a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4019,
    stopColor: "#84438f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7073,
    stopColor: "#5e3b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.778,
    x2: 284.964,
    xlinkHref: "#lg4",
    y1: 253.63,
    y2: 391.404
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.73,
    x2: 469.55,
    xlinkHref: "#lg2",
    y1: 144.496,
    y2: 314.734
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.382,
    x2: 331.225,
    xlinkHref: "#lg3",
    y1: 293.197,
    y2: 242.494
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.117,
    x2: 266.031,
    xlinkHref: "#lg2",
    y1: 193.713,
    y2: 309.264
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.889,
    x2: 142.347,
    xlinkHref: "#lg2",
    y1: 221.433,
    y2: 256.245
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.998,
    x2: 327.798,
    xlinkHref: "#lg3",
    y1: 304.106,
    y2: 184.406
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.858,
    x2: 63.906,
    xlinkHref: "#lg3",
    y1: 339.875,
    y2: 206.923
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#fb3f6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#f12357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.616,
    x2: 124.064,
    xlinkHref: "#lg5",
    y1: 218.393,
    y2: 268.469
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.428,
    x2: 166.139,
    xlinkHref: "#lg6",
    y1: 154.915,
    y2: 154.915
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.015,
    x2: 202.154,
    xlinkHref: "#lg6",
    y1: 223.378,
    y2: 256.809
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.2,
    x2: 276.339,
    xlinkHref: "#lg6",
    y1: 223.378,
    y2: 256.809
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.957,
    x2: 312.957,
    xlinkHref: "#lg4",
    y1: 337.363,
    y2: 379.819
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.679,
    x2: 208.673,
    xlinkHref: "#lg2",
    y1: 363.851,
    y2: 412.845
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 819.321)",
    gradientUnits: "userSpaceOnUse",
    x1: 43.869,
    x2: 81.231,
    xlinkHref: "#lg2",
    y1: 434.565,
    y2: 471.927
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.517,
    x2: 160.308,
    xlinkHref: "#lg3",
    y1: 386.274,
    y2: 339.454
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.372,
    x2: 295.366,
    xlinkHref: "#lg2",
    y1: 363.851,
    y2: 412.845
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 819.321)",
    gradientUnits: "userSpaceOnUse",
    x1: -42.824,
    x2: -5.463,
    xlinkHref: "#lg2",
    y1: 434.565,
    y2: 471.927
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.21,
    x2: 247.001,
    xlinkHref: "#lg3",
    y1: 386.274,
    y2: 339.454
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.065,
    x2: 382.059,
    xlinkHref: "#lg2",
    y1: 363.851,
    y2: 412.845
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 819.321)",
    gradientUnits: "userSpaceOnUse",
    x1: -129.517,
    x2: -92.156,
    xlinkHref: "#lg2",
    y1: 434.565,
    y2: 471.927
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.903,
    x2: 333.694,
    xlinkHref: "#lg3",
    y1: 386.274,
    y2: 339.454
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.758,
    x2: 468.752,
    xlinkHref: "#lg2",
    y1: 363.851,
    y2: 412.845
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 819.321)",
    gradientUnits: "userSpaceOnUse",
    x1: -216.211,
    x2: -178.849,
    xlinkHref: "#lg2",
    y1: 434.565,
    y2: 471.927
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.596,
    x2: 420.388,
    xlinkHref: "#lg3",
    y1: 386.274,
    y2: 339.454
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.075,
    x2: 313.075,
    xlinkHref: "#lg2",
    y1: 336.823,
    y2: 354.462
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.131,
    x2: 101.745,
    xlinkHref: "#lg5",
    y1: 363.334,
    y2: 421.314
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.55,
    x2: 21.77,
    xlinkHref: "#lg5",
    y1: 393.062,
    y2: 373.611
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.822,
    x2: 94.362,
    xlinkHref: "#lg5",
    y1: 375.904,
    y2: 375.904
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.257,
    x2: 51.989,
    xlinkHref: "#lg5",
    y1: 377.544,
    y2: 373.653
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 495.66,
    x2: 360.441,
    xlinkHref: "#lg3",
    y1: 203.492,
    y2: 68.273
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.506,
    x2: 454.397,
    xlinkHref: "#lg6",
    y1: 94.798,
    y2: 161.638
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.836,
    x2: 457.456,
    xlinkHref: "#lg5",
    y1: 78.812,
    y2: 153.846
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.579,
    x2: 301.579,
    xlinkHref: "#lg1",
    y1: 370.371,
    y2: 381.264
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.224,
    x2: 168.312,
    xlinkHref: "#lg3",
    y1: 401.396,
    y2: 372.485
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.491,
    x2: 179.898,
    xlinkHref: "#lg6",
    y1: 373.663,
    y2: 384.07
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.917,
    x2: 255.006,
    xlinkHref: "#lg3",
    y1: 401.396,
    y2: 372.485
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.184,
    x2: 266.591,
    xlinkHref: "#lg6",
    y1: 373.663,
    y2: 384.07
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.611,
    x2: 341.699,
    xlinkHref: "#lg3",
    y1: 401.396,
    y2: 372.485
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.877,
    x2: 353.284,
    xlinkHref: "#lg6",
    y1: 373.663,
    y2: 384.07
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 457.304,
    x2: 428.392,
    xlinkHref: "#lg3",
    y1: 401.396,
    y2: 372.485
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.571,
    x2: 439.977,
    xlinkHref: "#lg6",
    y1: 373.663,
    y2: 384.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m506.073 210.552h-12.78c-.31-.079-.63-.133-.965-.133s-.654.055-.964.133h-26.869c-.31-.079-.63-.133-.965-.133s-.654.055-.965.133h-17.565v7.854h14.603v15.679c0 2.169 1.758 3.927 3.927 3.927s3.927-1.758 3.927-3.927v-15.679h20.944v15.679c0 2.169 1.758 3.927 3.927 3.927s3.927-1.758 3.927-3.927v-15.679h9.818c2.169 0 3.927-1.758 3.927-3.927s-1.758-3.927-3.927-3.927z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m238.01 152.616h-52.156c0-7.908 6.411-14.319 14.32-14.319h23.517c7.908-.001 14.319 6.41 14.319 14.319z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m243.526 170.986h-63.188v-12.979c0-4.041 3.276-7.317 7.317-7.317h48.553c4.041 0 7.318 3.276 7.318 7.317z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m176.443 103.313h-64.755v21.962c0 6.133 2.896 11.906 7.811 15.574 4.916 3.668 7.811 9.441 7.811 15.574v21.581h33.51v-21.581c0-6.133 2.896-11.906 7.811-15.574 4.916-3.668 7.811-9.441 7.811-15.574v-21.962z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m168.632 140.848c4.916-3.668 7.811-9.441 7.811-15.574v-21.961h-64.755v7.239l49.133 49.132v-3.263c0-6.132 2.895-11.905 7.811-15.573z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m171.658 111.992h-55.185c-4.794 0-8.68-3.886-8.68-8.68 0-4.794 3.886-8.68 8.68-8.68h55.185c4.794 0 8.68 3.886 8.68 8.68 0 4.794-3.886 8.68-8.68 8.68z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m136.589 309.059h226.434v34.103h-226.434z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m450.337 234.882v-33.403c0-21.402 17.35-38.753 38.753-38.753 6.307 0 11.42-5.113 11.42-11.42v-17.884h-145.194v203.016h145.194v-97.243c0-2.382-1.931-4.314-4.314-4.314h-45.859z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m355.316 336.439h145.194v-33.22l-133.21-133.21c-3.659-4.342-7.71-6.91-11.984-7.243z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m354.364 162.726v-.003h-238.454c-16.901 0-30.614 34.827-30.614 77.779 0 42.953 13.713 77.779 30.614 77.779h238.453c16.908 0 30.615-34.822 30.615-77.778.001-42.955-13.706-77.777-30.614-77.777z",
    fill: "url(#SVGID_10_)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.914,
    cy: 240.504,
    fill: "url(#SVGID_11_)",
    rx: 30.615,
    ry: 77.778
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m384.979 240.504c0-1.893-.036-3.763-.088-5.622h-299.497c-.063 1.857-.097 3.73-.097 5.621 0 42.953 16.583 77.779 37.023 77.779h232.044c16.908 0 30.615-34.822 30.615-77.778z",
    fill: "url(#SVGID_12_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m115.91 318.282h124.374l-132.929-132.929c-3.134-3.802-6.642-5.934-10.347-5.934-.016 0-.032.003-.048.003-7.103 14.245-11.663 36.311-11.663 61.081 0 42.952 13.712 77.779 30.613 77.779z",
    fill: "url(#SVGID_13_)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.008,
    cy: 240.504,
    fill: "url(#SVGID_14_)",
    rx: 24.045,
    ry: 61.086
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m126.442 150.69c.567 1.836.868 3.765.868 5.732v2.717h33.51v-2.717c0-1.967.301-3.897.868-5.732z",
    fill: "url(#SVGID_15_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m173.16 159.762c-.016 0-.032 0-.048 0-1.531.006-2.156 2.043-.904 2.923 13.428 9.439 23.288 40.701 23.288 77.819s-9.859 68.38-23.288 77.819c-1.253.88-.627 2.917.904 2.923h.048c17.553 0 31.782-36.15 31.782-80.742s-14.23-80.742-31.782-80.742z",
    fill: "url(#SVGID_16_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m247.345 159.762c-.016 0-.032 0-.048 0-1.531.006-2.156 2.043-.904 2.923 13.428 9.439 23.287 40.701 23.287 77.819s-9.859 68.38-23.287 77.819c-1.253.88-.627 2.917.904 2.923h.048c17.553 0 31.782-36.15 31.782-80.742s-14.229-80.742-31.782-80.742z",
    fill: "url(#SVGID_17_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m115.914 379.918h386.976c3.927 0 7.109-3.183 7.109-7.109v-29.26c0-3.926-3.183-7.109-7.109-7.109h-386.976z",
    fill: "url(#SVGID_18_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 171.539,
    cy: 375.711,
    fill: "url(#SVGID_19_)",
    r: 39.656
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.539,
    cy: 375.711,
    fill: "url(#SVGID_20_)",
    r: 30.24
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m138.039 354.503 54.709 54.709c11.084-7.032 18.447-19.402 18.447-33.501 0-21.901-17.755-39.656-39.656-39.656-14.098.001-26.468 7.364-33.5 18.448z",
    fill: "url(#SVGID_21_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.232,
    cy: 375.711,
    fill: "url(#SVGID_22_)",
    r: 39.656
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.232,
    cy: 375.711,
    fill: "url(#SVGID_23_)",
    r: 30.24
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m224.732 354.503 54.709 54.709c11.084-7.032 18.447-19.402 18.447-33.501 0-21.901-17.754-39.656-39.656-39.656-14.098.001-26.468 7.364-33.5 18.448z",
    fill: "url(#SVGID_24_)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.925,
    cy: 375.711,
    fill: "url(#SVGID_25_)",
    r: 39.656
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.925,
    cy: 375.711,
    fill: "url(#SVGID_26_)",
    r: 30.24
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m311.425 354.503 54.709 54.709c11.084-7.032 18.447-19.402 18.447-33.501 0-21.901-17.755-39.656-39.656-39.656-14.098.001-26.468 7.364-33.5 18.448z",
    fill: "url(#SVGID_27_)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 431.618,
    cy: 375.711,
    fill: "url(#SVGID_28_)",
    r: 39.656
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 431.618,
    cy: 375.711,
    fill: "url(#SVGID_29_)",
    r: 30.24
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m398.118 354.503 54.709 54.709c11.084-7.032 18.447-19.402 18.447-33.501 0-21.901-17.754-39.656-39.656-39.656-14.097.001-26.468 7.364-33.5 18.448z",
    fill: "url(#SVGID_30_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m116.151 354.503h390.895c1.631 0 2.954-1.322 2.954-2.954v-12.156c0-1.631-1.322-2.954-2.954-2.954h-390.895z",
    fill: "url(#SVGID_31_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m6.379 415.367h115.936c3.777 0 6.839-3.062 6.839-6.839v-65.25c0-3.777-3.062-6.839-6.839-6.839h-31.696c-10.404 0-20.418 3.962-28.006 11.08l-60.59 56.839c-4.208 3.948-1.414 11.009 4.356 11.009z",
    fill: "url(#SVGID_32_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m8.818 408.647c-.173 0-.701 0-.96-.657-.258-.652.125-1.01.25-1.128l55.732-51.969c1.143-1.066 2.916.237 2.239 1.646l-22.737 47.342c-1.399 2.913-4.344 4.765-7.575 4.765h-26.949z",
    fill: "url(#SVGID_33_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m100.731 402.79 9.16-55.413c.402-2.431 2.504-4.215 4.969-4.215 3.598 0 6.515 2.917 6.515 6.515v52.455c0 3.598-2.917 6.515-6.515 6.515h-9.16c-3.11 0-5.476-2.79-4.969-5.857z",
    fill: "url(#SVGID_34_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m58.591 395.527 22.654-47.17c1.492-3.107 4.601-5.17 8.047-5.194.078 0 .156-.001.234-.001 5.653 0 9.955 5.072 9.033 10.649l-7.798 47.173c-.731 4.42-4.553 7.663-9.033 7.663h-14.883c-6.743 0-11.173-7.042-8.254-13.12z",
    fill: "url(#SVGID_35_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m355.316 138.067 95.021 95.021v-31.609c0-21.403 17.35-38.753 38.753-38.753 6.307 0 11.419-5.113 11.419-11.42v-17.884h-145.193z",
    fill: "url(#SVGID_36_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m498.881 138.296h-141.936c-3.28 0-5.939-2.659-5.939-5.939v-8.064h153.814v8.064c0 3.28-2.659 5.939-5.939 5.939z",
    fill: "url(#SVGID_37_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m505.68 129.74h-155.534c-2.386 0-4.32-1.934-4.32-4.32v-15.097c0-2.386 1.934-4.32 4.32-4.32h155.534c2.386 0 4.32 1.934 4.32 4.32v15.097c0 2.386-1.934 4.32-4.32 4.32z",
    fill: "url(#SVGID_38_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m171.539 370.134h260.079v11.155h-260.079z",
    fill: "url(#SVGID_39_)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m198.716 388.981-19.76-19.76c-1.808-2.064-4.457-3.375-7.417-3.375-5.448 0-9.865 4.417-9.865 9.865 0 2.96 1.31 5.608 3.375 7.417l19.76 19.76c6.042-2.956 10.951-7.865 13.907-13.907z",
    fill: "url(#SVGID_40_)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.539,
    cy: 375.711,
    fill: "url(#SVGID_41_)",
    r: 9.865
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m285.409 388.981-19.76-19.76c-1.808-2.064-4.457-3.375-7.417-3.375-5.448 0-9.865 4.417-9.865 9.865 0 2.96 1.31 5.608 3.375 7.417l19.76 19.76c6.042-2.956 10.951-7.865 13.907-13.907z",
    fill: "url(#SVGID_42_)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.232,
    cy: 375.711,
    fill: "url(#SVGID_43_)",
    r: 9.865
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m372.102 388.981-19.76-19.76c-1.808-2.064-4.457-3.375-7.416-3.375-5.448 0-9.865 4.417-9.865 9.865 0 2.96 1.31 5.608 3.374 7.417l19.76 19.76c6.042-2.956 10.951-7.865 13.907-13.907z",
    fill: "url(#SVGID_44_)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.925,
    cy: 375.711,
    fill: "url(#SVGID_45_)",
    r: 9.865
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m458.795 388.981-19.76-19.76c-1.808-2.064-4.457-3.375-7.417-3.375-5.448 0-9.865 4.417-9.865 9.865 0 2.96 1.31 5.608 3.375 7.417l19.76 19.76c6.042-2.956 10.952-7.865 13.907-13.907z",
    fill: "url(#SVGID_46_)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 431.618,
    cy: 375.711,
    fill: "url(#SVGID_47_)",
    r: 9.865
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrain);
export default __webpack_public_path__ + "static/media/icon-train.d5e704e01f3fa5649947665f42e5b248.svg";
export { ForwardRef as ReactComponent };